import { showAlert } from './alerts';
const communityAdmin = document.querySelector('.communityAdmin');

if (communityAdmin) {
  // Gérer les boutons de catégorie
  document.querySelectorAll('.community__newTopic--btnCat').forEach((btn) => {
    btn.addEventListener('click', () => {
      const topicId = btn.dataset.id;
      const select = document.getElementById(`category-${topicId}`);
      select.value = btn.dataset.value;

      // Désactiver tous les boutons dans le même groupe
      const parent = btn.closest('.category-buttons');
      parent.querySelectorAll('.community__newTopic--btnCat').forEach((b) => b.classList.remove('active'));

      // Activer le bouton cliqué
      btn.classList.add('active');
    });
  });

  // Gérer les boutons de langue
  document.querySelectorAll('.community__newTopic--btnLang').forEach((btn) => {
    btn.addEventListener('click', () => {
      const topicId = btn.dataset.id;
      const select = document.getElementById(`language-${topicId}`);
      select.value = btn.dataset.value;

      // Désactiver tous les boutons dans le même groupe
      const parent = btn.closest('.language-buttons');
      parent.querySelectorAll('.community__newTopic--btnLang').forEach((b) => b.classList.remove('active'));

      // Activer le bouton cliqué
      btn.classList.add('active');
    });
  });

  document.querySelectorAll('.community__toggle-message').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.toggle;
      const el = document.getElementById(`message-${id}`);
      if (el) el.classList.toggle('hidden');
    });
  });

  // Soumission pour approbation
  document.querySelectorAll('.community__form:not(.community__form--delete)').forEach((form) => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const topicId = this.dataset.id;
      const wrapper = document.querySelector(`[data-topic-id="${topicId}"]`);
      const category = wrapper.querySelector(`select[name="category"]`).value;
      const language = wrapper.querySelector(`select[name="language"]`).value;

      try {
        const response = await fetch(`/api/v1/community/topic/${topicId}/approve`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ category, language }),
        });

        const result = await response.json();
        if (result.status === 'success') {
          showAlert('success', 'Sujet approuvé avec succès.');
          setTimeout(() => location.reload(), 1000);
        } else {
          showAlert('error', result.message || 'Erreur lors de l’approbation.');
        }
      } catch (err) {
        console.error('❌ Erreur API :', err);
        showAlert('error', 'Erreur serveur.');
      }
    });
  });

  // Soumission pour suppression
  document.querySelectorAll('.community__form--delete').forEach((form) => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const topicId = this.dataset.id;

      try {
        const response = await fetch(`/api/v1/community/topic/${topicId}`, {
          method: 'DELETE',
        });

        const result = await response.json();
        if (result.status === 'success') {
          showAlert('success', 'Sujet supprimé avec succès.');
          setTimeout(() => location.reload(), 1000);
        } else {
          showAlert('error', result.message || 'Erreur lors de la suppression.');
        }
      } catch (err) {
        console.error('❌ Erreur suppression :', err);
        showAlert('error', 'Erreur serveur.');
      }
    });
  });
}
